import React from 'react';
import { getSectionClasses } from '../../utils/styleUtils';

/**
 * Reusable Section component with consistent layout and spacing
 * 
 * @param {Object} props - Component props
 * @param {string} props.variant - Section variant (default, hero, contentWithBg, cta, etc.)
 * @param {string} props.containerVariant - Container variant (default, narrow, wide, form)
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Section content
 * @param {string} props.as - HTML element to render as (default: 'section')
 * @param {Object} props.rest - Additional props
 */
const Section = ({ 
  variant = 'default',
  containerVariant = 'default',
  className = '', 
  children,
  as: Component = 'section',
  ...rest 
}) => {
  const sectionClasses = getSectionClasses(variant, containerVariant, className);

  return (
    <Component
      className={sectionClasses}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Section;